<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-card outlined class="rounded-lg">
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="segments"
              hide-default-footer
              disable-pagination
              class="elevation-0"
            >
              <template v-slot:item.action="{ item }">
                <v-btn
                  icon
                  small
                  @click="editItem(item)"
                >
                  <v-icon
                    small
                  >
                    {{ mdiPencil }}
                  </v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="600px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Edit segments for {{ editedItem.level_name }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="editedItem.level_name"
                  label="Level name"
                  filled
                  hide-details
                  disabled
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="editedItem.number_of_segments"
                  label="Number of Segments"
                  filled
                  type="number"
                  v-validate="{
                    required: true,
                    min: 1
                  }"
                  name="number"
                  :error-messages="errors.collect('number')"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
          <v-btn color="blue darken-1" dark @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mdiPencil } from '@mdi/js';
export default {
  data () {
    return {
      mdiPencil,
      dialog: false,
      segments: [],
      headers: [
        {
          text: 'Level Name',
          value: 'level_name',
          sortable: false,
        },
        {
          text: 'Number of Segments',
          value: 'number_of_segments',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Actions',
          value: 'action',
          align: 'center',
          sortable: false,
        },
      ],
      editedIndex: -1,
      editedItem: {
        name: '',
        number_of_segments: ''
      },
      defaultItem: {
        name: '',
        number_of_segments: ''
      },
    }
  },
  async mounted () {
    await this.getSegments()
  },
  methods: {
    async getSegments () {
      this.loading = true
      const { data } = await this.$axios.get(this.$store.getters.projectPath + '/segments')
      .catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.segments = data
      }
      this.loading = false
    },
    editItem (item) {
      this.editedIndex = this.segments.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    close () {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    async save () {
      const { data } = await this.$axios.put(
        this.$store.getters.projectPath + '/configs/segments/' + this.editedItem.id,
        this.editedItem
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        const index = this.segments.findIndex(segment => segment.level_name === data.level_name)
        if (index !== -1) {
          this.$set(this.segments, index, data)
        }
        this.close()
      }
    },
  }
}
</script>